export const CURRENT_USER = 'current-user';
export const COOKIE_EXPIRY_DAYS = 1;
export const REMEMBER_ME = 'rememberMe';
export const HMS_THEME = 'hmsTheme';
export const MODULE_NOTIFICATIONS = 'moduleNotifications';
